export default "__VITE_ASSET__fec6X3Ck__"